import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 12l-4 -4l-4 4","key":"svg-0"}],["path",{"d":"M12 16v-8","key":"svg-1"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z","key":"svg-2"}]]

const IconSquareRoundedArrowUp = createReactComponent('outline', 'square-rounded-arrow-up', 'SquareRoundedArrowUp', __iconNode);

export default IconSquareRoundedArrowUp;